import React, { createContext, useContext, useState, useMemo, useCallback } from "react";
import { translations } from "./translations";

const LanguageContext = createContext(null);

export function LanguageProvider({ children }) {
  const [lang, setLang] = useState(() => {
    if (typeof window !== "undefined") {
      const saved = localStorage.getItem("brc_lang");
      if (saved === "en" || saved === "es") return saved;
      const browser = (navigator.language || "en").toLowerCase();
      return browser.startsWith("es") ? "es" : "en";
    }
    return "en";
  });

  const setLanguage = useCallback((l) => {
    setLang(l);
    if (typeof window !== "undefined") localStorage.setItem("brc_lang", l);
  }, []);

  const value = useMemo(() => {
    const t = translations[lang] || translations.en;
    return { lang, setLanguage, t };
  }, [lang, setLanguage]);

  return <LanguageContext.Provider value={value}>{children}</LanguageContext.Provider>;
}

export function useLang() {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error("useLang must be used within LanguageProvider");
  return ctx;
}
